import React, { useId } from 'react';
import { styled } from 'styled-components';
import { ActionIcon, StyledActionIcon } from './ActionIcon';
import { globalOutline } from '../../../../../play-core/styles/style-helper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ToggleActionIcon = ({
  ariaTitle,
  isActive,
  inactiveIcon,
  activeIcon,
  onClick,
  isHovering,
  withOuterPadding = true
}) => {
  const id = useId();
  return /*#__PURE__*/_jsxs(ActionIconContainer, {
    children: [/*#__PURE__*/_jsx(AriaInput, {
      id: id,
      type: "checkbox",
      onChange: onClick,
      checked: isActive,
      "aria-label": ariaTitle
    }), /*#__PURE__*/_jsx(ActionIcon, {
      isActive: isActive,
      onClick: onClick,
      isHovering: isHovering,
      withOuterPadding: withOuterPadding,
      icon: isActive ? activeIcon : inactiveIcon
    })]
  });
};
const ActionIconContainer = styled.div.withConfig({
  displayName: "ToggleActionIcon__ActionIconContainer",
  componentId: "sc-18l044n-0"
})(["cursor:pointer;display:flex;pointer-events:all;"]);
const AriaInput = styled.input.withConfig({
  displayName: "ToggleActionIcon__AriaInput",
  componentId: "sc-18l044n-1"
})(["width:0;opacity:0;&.focus-visible{~ ", "{opacity:1;", ";transform:scale(1.1);}}"], StyledActionIcon, globalOutline);